import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-modal";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import Loader from "../../ui/Loader";
import { BodyBuilder } from "../../../exports/Images";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { deleteTestimonial } from "../../../data/ApiEndpoints";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import TestimonialForm from "./TestimonialForm";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { CrossCircleIcon } from "../../../images/icons/icons";

const AllTestimonial = ({
  isPage,
  setIsPage,
  callFunction,
  userInfoData,
  modValues,
  setModValues,
  onCloseModalvalues,
}) => {
  const dispatch = useDispatch();
  const { loading, testimonialData } = useSelector((state) => state.webApi);

  const { data, pagination } = testimonialData || {};
  const { isModOpen, cardName } = modValues || {};

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: deleteTestimonial,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "category",
      text: "category",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.category || "NA"}</span>;
      },
    },
    {
      dataField: "user_name",
      text: "User name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.user_name && row?.user_name !== "null" ? row.user_name : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "rating",
      text: "rating",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.rating && row?.rating !== "null" ? row.rating : 0}{" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-star-fill"
              viewBox="0 0 16 16"
            >
              <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
            </svg>
          </span>
        );
      },
    },
    {
      dataField: "type",
      text: "type",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.type || "NA"}</span>;
      },
    },
    {
      dataField: "media",
      text: "media",
      formatter: (cell, row) => {
        return (
          <>
            {row?.type === "image" ? (
              <div
                className="tb-img lightBorderRadiusImg"
                style={{
                  cursor: row?.media ? "pointer" : "not-allowed",
                  minWidth: "200px",
                }}
              >
                <img
                  src={row?.media || BodyBuilder}
                  alt={row?.uid || "NA"}
                  className="image"
                  style={{
                    cursor: row?.media ? "pointer" : "not-allowed",
                    width: "80%",
                    height: "130px",
                  }}
                  onClick={() =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      viewImage: row?.media || BodyBuilder,
                      cardName: "image",
                    }))
                  }
                />
              </div>
            ) : row?.type === "video" ? (
              <div
                className="tb-play-btn"
                style={{
                  width: "auto",
                }}
              >
                <button
                  className="play-btn"
                  type="button"
                  onClick={() =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: row?.media ? true : false,
                      viewVideo: row?.media ? row?.media : "",
                      cardName: "video",
                    }))
                  }
                  style={{
                    cursor: row?.media ? "pointer" : "not-allowed",
                    minWidth: "200px",
                  }}
                >
                  {row?.media ? (
                    <>
                      <div className="discussionModalMessage mt30">
                        <video width="200" height="150" controls>
                          <source src={row.media}></source>
                        </video>
                      </div>

                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-play-circle"
                        viewBox="0 0 16 16"
                        style={{ color: "rgb(52, 116, 241)" }}
                      >
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                      </svg> */}
                    </>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-ban"
                      viewBox="0 0 16 16"
                      style={{ color: "#787878" }}
                    >
                      <path d="M15 8a6.97 6.97 0 0 0-1.71-4.584l-9.874 9.875A7 7 0 0 0 15 8M2.71 12.584l9.874-9.875a7 7 0 0 0-9.874 9.874ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0" />
                    </svg>
                  )}
                </button>
              </div>
            ) : (
              "NA"
            )}
          </>
        );
      },
    },
    {
      dataField: "thumbnail",
      text: "thumbnail",
      formatter: (cell, row) => {
        return (
          <>
            {row?.thumbnail ? (
              <div
                className={`tb-img`}
                style={{
                  cursor: row?.thumbnail ? "pointer" : "not-allowed",
                  minWidth: "200px",
                }}
              >
                <img
                  src={row?.thumbnail || BodyBuilder}
                  alt={row?.uid || "NA"}
                  className="image"
                  style={{
                    cursor: row?.thumbnail ? "pointer" : "not-allowed",
                    width: "80%",
                    height: "180px",
                    objectFit: "cover",
                  }}
                  onClick={() =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      viewImage: row?.thumbnail || BodyBuilder,
                      cardName: "image",
                    }))
                  }
                />
              </div>
            ) : (
              <span className="tb-data icon">
                <CrossCircleIcon />
              </span>
            )}
          </>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          {row?.media_subtitle && (
            <button
              className="actionBtn icon view"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "description",
                  description: row?.media_subtitle,
                }))
              }
              style={{
                border: "1px solid #bc0909",
                color: "#bc0909",
                borderRadius: "12px",
                cursor: "pointer",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-view-list"
                viewBox="0 0 16 16"
              >
                <path d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2m0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14" />
              </svg>
            </button>
          )}

          <button
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "edit",
              }))
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil-fill"
              viewBox="0 0 16 16"
            >
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </button>

          <button
            className="actionBtn icon delete"
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete(uidFilter);
            }}
          >
            {loading ? (
              <Loader />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-trash3-fill"
                viewBox="0 0 16 16"
              >
                <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
              </svg>
            )}
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        isOpen={isModOpen}
        onRequestClose={onCloseModalvalues}
        contentLabel="Testimonial Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.cardName === "description" ? "midWidthModal" : ""
          }`}
          style={{
            width: cardName === "image" || cardName === "video" ? "auto" : "",
            height: cardName === "image" || cardName === "video" ? "auto" : "",
          }}
        >
          {cardName !== "add" && cardName !== "edit" ? (
            <ModalHeadAndClose
              title={`${cardName?.replace(/_/g, " ")}`}
              onClose={onCloseModalvalues}
            />
          ) : null}

          {cardName === "add" || cardName === "edit" ? (
            <TestimonialForm
              userInfoData={userInfoData}
              callFunction={callFunction}
              closeModal={onCloseModalvalues}
              isEdit={cardName === "edit"}
              rowData={modValues.rowData}
            />
          ) : cardName === "image" ? (
            <div className="discussionModalMessage mt30">
              <img
                src={modValues.viewImage}
                alt="profile"
                style={{
                  width: "400px",
                  height: "400px",
                }}
              />
            </div>
          ) : cardName === "video" ? (
            <div className="discussionModalMessage mt30">
              <video width="320" height="240" controls>
                <source src={modValues.viewVideo}></source>
              </video>
            </div>
          ) : modValues.cardName === "description" ? (
            <div className="discussionModalMessage mt30">
              <p
                className="message"
                dangerouslySetInnerHTML={{
                  __html: modValues?.description || "No Content Available",
                }}
              ></p>
            </div>
          ) : null}
        </div>
      </Modal>

      <div className="fullWidthFlexCenter overflowAuto separatedTable">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={data?.length > 0 ? data : []}
            tableColumns={tbColumns}
            tablePagination={pagination?.length > 0 ? pagination : []}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
          />
        )}
      </div>
    </>
  );
};

export default AllTestimonial;
